import React from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import PageShell, { SectionCard } from "components/patch/PageShell";

export default function FAQs() {
  return (
    <PageShell title="FAQs & User Guide" subtitle="Quick guidance for payroll officers, reviewers, approvers and super admin.">
      <SectionCard title="Information">
        <MDTypography variant="button" color="text" fontWeight="regular">
          Keep your project-specific manual here. This patch removes the blank-page crash and gives you a working page to expand.
        </MDTypography>
      </SectionCard>
    </PageShell>
  );
}
